import type { MouseEvent } from 'react'

/** Enlace de pago del método Curly Seducción. */
export const CHECKOUT_URL =
  'https://origenprime.com/checkouts/cn/hWNGgaT8XSKWkAcyAiZ7suJe/en-us?_r=AQAB3N1zSZ0EmRcYl0KCaQ3CrKEpc9wI7MBqPcqXHfkSeKw&cart_link_id=ppF5ynGu&preview_theme_id=143627485282'

/**
 * Abre el checkout en una pestaña nueva. Dentro de un iframe (previsualización)
 * la navegación directa se bloquea, por eso forzamos la apertura por JS y,
 * si el navegador la impide, saltamos a la ventana superior.
 */
export function openCheckout(event?: MouseEvent<HTMLElement>) {
  event?.preventDefault()

  const opened = window.open(CHECKOUT_URL, '_blank', 'noopener,noreferrer')
  if (opened) return

  try {
    if (window.top) {
      window.top.location.href = CHECKOUT_URL
      return
    }
  } catch {
    /* cross-origin: caemos al último recurso */
  }

  window.location.href = CHECKOUT_URL
}
